<div id="last_step" class="mt-3">
  <app-associata-box
    [tvAssociata]="tvAssociata"
    (set)="settaAssociata($event)"
    (reset)="resettaAssociata()"
    *ngIf="tvAssociata"
  ></app-associata-box>

  <div class="row" [ngClass]="tvAssociata ? 'mt-5' : 'mt-0'">
    <div class="col-12">
      <div class="riepilogo">
        <div class="line-head">
          <div class="head">
            {{ "base.riepilogo" | translate }}
          </div>
          <hr class="divisore" />
        </div>

        <div class="line">
          <div class="riepilogo__label nomin">
            {{ "base.qta_vino" | translate }}
          </div>
          <div class="riepilogo__total d-flex justify-content-end">
            <div
              class="input-group counter d-flex justify-content-center w-fit"
            >
              <span class="input-group-btn">
                <button
                  class="btn minus stroked-blue"
                  type="button"
                  mat-stroked-button
                  (click)="vinoMeno()"
                >
                  <span class="material-symbols-outlined"> remove </span>
                </button>
              </span>
              <span class="counter-item stroked-blue">{{ vino.qta }}</span>
              <span class="input-group-btn">
                <button
                  class="btn plus stroked-blue"
                  type="button"
                  mat-stroked-button
                  (click)="vinoPiu()"
                >
                  <span class="material-symbols-outlined"> add </span>
                </button>
              </span>
            </div>
          </div>
        </div>
        <div class="line" *ngIf="vino.annate && vino.annate.length > 0">
          <label class="riepilogo__label">
            {{ "base.annata" | translate }}
          </label>
          <span class="riepilogo__total" [formGroup]="formAnnata">
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "base.seleziona_annata" | translate }}
              </mat-label>
              <mat-select formControlName="annata" name="annata">
                <mat-option
                  *ngFor="let annata of vino.annate"
                  [value]="annata.idAnnata"
                >
                  <span>{{ annata.annata }}</span>
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  formAnnata.get('annata').invalid &&
                  (formAnnata.get('annata').dirty ||
                    formAnnata.get('annata').touched)
                "
              >
                {{ "generale.rischiesto" | translate }}
              </mat-error>
            </mat-form-field>
          </span>
        </div>

        <hr class="divisore" *ngIf="promoSelezionata" />

        <div
          class="line"
          *ngIf="promoSelezionata && promoSelezionata.risultato"
        >
          <label class="riepilogo__label">
            {{ "prenotazioni.labelCodiceUsato" | translate }}
          </label>
          <div class="riepilogo__total">
            <div>
              {{ promoSelezionata.promo.titolo }}
            </div>
            <div>
              <div>
                {{ promoSelezionata.promo.codice }}
              </div>
              <div>
                <b>
                  {{ promoSelezionata.promo.codice }}
                </b>
                <b>
                  - {{ promoSelezionata.promo.tipo === "0" ? "€" : "%" }}
                  {{ promoSelezionata.promo.valore }}
                </b>
              </div>
            </div>
          </div>
        </div>
        <div
          class="line"
          *ngIf="
            promoSelezionata &&
            promoSelezionata.errore == 'promodialogo.scaduta'
          "
        >
          <label class="riepilogo__label">
            {{ "base.errore" | translate }}
          </label>
          <span class="riepilogo__total bold">
            {{ "promodialogo.scaduta" | translate }}
          </span>
        </div>
        <div
          class="line"
          *ngIf="
            promoSelezionata &&
            promoSelezionata.errore == 'promodialogo.nonvalido'
          "
        >
          <label class="riepilogo__label">
            {{ "base.errore" | translate }}
          </label>
          <span class="riepilogo__total bold">
            {{ "promodialogo.nonvalido" | translate }}
          </span>
        </div>
        <div
          class="line"
          *ngIf="
            promoSelezionata &&
            promoSelezionata.errore == 'promodialogo.importominimo'
          "
        >
          <label class="riepilogo__label">
            {{ "base.errore" | translate }}
          </label>
          <span class="riepilogo__total bold">
            {{ promoSelezionata.errore | translate }}
            {{
              promoSelezionata.errore == "promodialogo.importominimo"
                ? "€" + promoSelezionata.promo.minimo
                : ""
            }}
          </span>
        </div>

        <hr class="divisore" />

        <div class="line">
          <label class="riepilogo__label">
            {{ "base.totale_vino" | translate }}
          </label>
          <div class="riepilogo__total">
            <span class="total" [ngClass]="{ barrato: promoSelezionata }">
              € {{ totaleVini | number : "1.2-2" }}
            </span>
            <span class="in-sconto total" *ngIf="promoSelezionata">
              € {{ totaleViniConPromo | number : "1.2-2" }}
            </span>
          </div>
        </div>

        <div class="line" *ngIf="tvSelezionata">
          <label class="riepilogo__label">
            {{ "base.totale_associata" | translate }}
          </label>
          <span class="riepilogo__total total">
            <span *ngIf="totaleTv > 0.0"
              >€ {{ totaleTv | number : "1.2-2" }}
            </span>
            <span *ngIf="totaleTv == 0.0">
              {{ "gite_extra.incluso" | translate | titlecase }}
            </span>
          </span>
        </div>

        <div class="line" *ngIf="tvSelezionata && !promoSelezionata">
          <label class="riepilogo__label">
            {{ "base.totale_associata_vino" | translate }}
          </label>
          <span class="riepilogo__total total">
            € {{ totaleGenerale | number : "1.2-2" }}
          </span>
        </div>

        <div class="line" *ngIf="promoSelezionata">
          <label class="riepilogo__label">
            {{ "base.totale_finale" | translate }}
          </label>
          <span class="riepilogo__total total">
            € {{ totalescontato | number : "1.2-2" }}
          </span>
        </div>
      </div>

      <div class="flex-actions mt-2">
        <div
          class="input__codice__wrapper"
          *ngIf="
            !promoSelezionata ||
            (promoSelezionata && !promoSelezionata.risultato)
          "
        >
          <mat-form-field class="input__codice" appearance="outline">
            <mat-label>
              {{ "base.codiceregalo_label" | translate }}
            </mat-label>
            <input
              matInput
              [(ngModel)]="codicePromo"
              placeholder="Es: 12-O45SS"
            />
          </mat-form-field>
          <button
            class="btn btn-green"
            (click)="riscattaCodice()"
            [disabled]="isDisabled()"
          >
            {{ "base.codiceregalo_btn" | translate }}
            <span class="material-symbols-outlined"> card_giftcard </span>
          </button>
        </div>
        <button class="btn btn-red" (click)="aggiungiAlCarrello()">
          {{ "base.aggiungi_carrello" | translate }}
          <span class="material-symbols-outlined"> shopping_bag </span>
        </button>
      </div>
    </div>
  </div>
</div>
